import React from 'react';
import PropTypes from 'prop-types';
import { UserCtx } from '../../../contexts/UserCtx';
import { ReactChildrenPropType } from '../../../lib/commonPropTypes';

export class Secure extends React.Component {
  /**
   * Whether access is permitted mostly dictated by @see UserCtx.allow
   * @returns {boolean}
   */
  get allow() {
    const { reqPermission, and, isOr } = this.props;
    const { context } = this;

    const permitted = context.allow(reqPermission, and, isOr);
    if (!permitted) {
      context.log(`Denied (reqPermission=${reqPermission}, and=${and})`);
    }
    return permitted;
  }

  render() {
    const { log } = this.context;
    const { altChildren, children } = this.props;

    // If not allowed return nothing (an empty fragment)
    if (!this.allow) {
      log('Secure: Hiding element');
      if (altChildren) {
        return altChildren;
      }
      return null;
    }
    // Otherwise it's allowed - render children
    // log('Secure: Showing element');
    return children;
  }
}

Secure.propTypes = {
  /**
   * Permission required to render $children (otherwise render $altText if provided, or nothing)
   */
  reqPermission: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  /**
   * Content to render if the user has permission
   */
  children: ReactChildrenPropType.isRequired,
  /**
   * Must also be true to allow access - good for resource based access constraints
   * eg: Obj.owner===user.id
   */
  and: PropTypes.bool,
  /**
   * Alternative children to show if the children are suppressed (by lacking permission)
   */
  altChildren: PropTypes.node,
  /**
   * Whether to use OR instead of AND (ignored if undefined)
   */
  isOr: PropTypes.bool
};

Secure.defaultProps = {
  and: true,
  altChildren: null,
  isOr: false
};

Secure.contextType = UserCtx;

export default Secure;
